
import MyAreaChart, { IChartSerie } from '@/Components/Charts/ReCharts/AreaChart/AreaChart'
import Icon from '@/Components/Icon/Icon'
import { getProgressData } from '@/Helpers/DashboardHelper'
import { getYMDFromDate } from '@/Helpers/DateFunctions'
import { useProgrammation } from '@/Hooks/UseProgrammation'
import { useProject } from '@/Hooks/UseProject'
import useTranslation from '@/Hooks/UseTranslation'
import { setDashboardProgressDataAction } from '@/Redux/Actions/DashboardActions'
import React, { useEffect, useMemo } from 'react'
import { Card } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'

const ProgressChart = () => {

  const { t } = useTranslation()
  const dispatch = useDispatch()

  const { project } = useProject()

  const { programmationLoaded } = useProgrammation()

  const dashboard = useSelector((state: any) => state.DashboardReducer)
  const { tasks, versions } = useSelector((state: any) => state.ProgrammationReducer)

  const colors = [
    {
      stroke: '#663299',
      fill: '#66329990'
    },
    {
      stroke: '#ff5721',
      fill: '#ff572190'
    }
  ]

  const nonWorkingDays = useMemo(() => {

    return project.nonWorkingDays.map((day: string) => {

      const date = new Date(day)

      return getYMDFromDate(date)
    })
  }, [ project.nonWorkingDays ])

  const series = useMemo(() => {

    const seriesNames: any = {
      Programado: t('DASHBOARD:ChartProgressProgrammed'),
      Real: t('DASHBOARD:ChartProgressActual')
    }

    const series: IChartSerie[] = []

    dashboard.progressData.forEach((item: any) => {

      Object.keys(item).forEach((key: string, i: number) => {

        if (key !== 'name' && key !== 'week') {

          if (series.find(serie => serie.name === seriesNames[key])) return

          series.push({
            name: seriesNames[key],
            color: colors ? colors[i - 1] : {
              stroke: '#828282',
              fill: '#82828290'
            }
          })
        }
      })
    })

    return series
  }, [ dashboard.progressData ])

  useEffect(() => {

    const loadProgressData = async () => {

      const options = {
        project,
        tasks: JSON.parse(JSON.stringify(tasks)),
        nonWorkingDays,
        versions: versions,
        weekLabel: t('DASHBOARD:ChartProgressWeekLabel')
      }

      const progressData = getProgressData(options)

      dispatch(setDashboardProgressDataAction(progressData.weeks))
    }

    if (programmationLoaded) {

      if (dashboard.loadProgressStatus === 'none') {

        loadProgressData()
      }
    }
  }, [ programmationLoaded, dashboard.loadProgressStatus ])

  return (
    <Card className="mb-3">
      <Card.Body>
        <Card.Title className="mb-3">
          {t('DASHBOARD:SummaryProjectProgress')}
        </Card.Title>
        <MyAreaChart
          data={dashboard.progressData}
          series={series}
          colors={[
            {
              stroke: '#663299',
              fill: '#66329990'
            },
            {
              stroke: '#ff5721',
              fill: '#ff572190'
            }
          ]}
          customTooltip={({ active, payload, label }: any) => {

            if (!active || !payload || !payload.length) return null

            return (
              <Card className="custom-tooltip"
                style={{ minWidth: '200px' }}
              >
                <Card.Header>
                  <Card.Title className="mb-0">
                    {t('DASHBOARD:SummaryProjectProgressWeek')} {label.split(' ')[1]}
                  </Card.Title>
                </Card.Header>
                <Card.Body>
                  <ul style={{ padding: '0 0 0 10px', margin: 0 }}>
                    {payload.map((item: any, i: number) => (
                      <li key={i} style={{
                        color: item.stroke,
                        // marginBottom: '5px'
                      }}>
                        <Icon name="dot" far />
                        <span>
                          {series[i].name}
                        </span>
                        <span>: {item.value}%</span>
                      </li>
                    ))}
                  </ul>
                </Card.Body>
              </Card>
            )
          }}
          strokeWidth={2}
          useGradients
        />
      </Card.Body>
    </Card>
  )
}

export default ProgressChart
